


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class HotSpecialItem extends Vue {
  @Prop({
    required: true,
    default: () => {
      return { title: null, coverUrl: null, bonus: null, competitors: null, navigationUrl: '' };
    },
  })
  private special;

  @Prop({
    required: false,
    default: () => {
      return '1';
    },
  })
  private type;

  handleClickItem() {
    if (this.special.navigationUrl.indexOf('datafountain.cn') > -1) {
      this.$router.push(this.special.navigationUrl.split('datafountain.cn')[1]);
    } else {
      this.$router.push(this.special.navigationUrl);
    }
  }
  get bonus() {
    return this.toThousands(this.special.bonus);
  }
  // 奖金序列化
  toThousands(num) {
    if (isNaN(Number(num))) return num;
    var result = '',
        counter = 0;
    num = (num || 0).toString();
    for (var i = num.length - 1; i >= 0; i--) {
      counter++;
      result = num.charAt(i) + result;
      if (!(counter % 3) && i != 0) {
        result = ',' + result;
      }
    }
    return `￥${result}`;
  }
}
